<template>
  <canvas :class="[hasLongTitle? 'mb-[5.68rem]': 'mb-16 pt-2 ', 'px-4 ' ]" ref="lineChart"></canvas>
</template>

<script setup>
import {defineEmits, defineProps, onMounted, ref, watch} from "vue";
import Chart from "chart.js/auto";
import ApiService from "@/services/ApiService";
let apiService = new ApiService;
import {useApiStore} from "@/stores/ApiStore";

const apiDataStore = useApiStore();
let props = defineProps({
  content: String,
  update: Number,
  source: String,
  style: Object,
  colorPalette: Object,
  type: String,
  hasLongTitle: Boolean
})
let emit =  defineEmits(["setPercentage", "changeLoaded"]);

let lineChart = ref(null);
let data = ref(Object);
let chart = ref();
let subject = ref("");
watch(() => props.update, () => {
  chart.value.destroy();
  emit("changeLoaded", false)
  refreshData();
})

async function refreshData() {
  let apiData = await apiService.get(props.source);
  data.value = apiData.data
  subject.value = apiData.subject;
  let total = data.value.periodTotal;
  if (data.value.isCurrency){
    total = formatter.format(parseInt(data.value.periodTotal)/100)
  }
  if (data.value.datasets.current.data.length < 2 && props.content ==="total-visits" ){
    chart.value = new Chart(lineChart.value, fillDataTotalVisits(data.value, props.style, props.colorPalette.lineChartCurrent, props.colorPalette.lineChartCompare))
  } else{
    chart.value = new Chart(lineChart.value, fillData(data.value, props.style, props.colorPalette.lineChartCurrent, props.colorPalette.lineChartCompare))
  }
  emit("setPercentage", [data.value.periodPercentage, total])
  emit("changeLoaded", true)
}


onMounted( async () => {
  await refreshData();
  }
)

const formatter = new Intl.NumberFormat(apiDataStore.getLang, {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2
});
function isWxFormat(str) {
  if (str.charAt(0) !== 'W') {
    return false;
  }
  return !isNaN(parseInt(str.charAt(1)));

}

function truncateLabels(labels){
  let newLabels = [];
  labels.forEach(entry => {
    if (isWxFormat(entry)){
      newLabels.push(entry)
    }
    else{
      if(apiDataStore.getLang === 'nl'){
        newLabels.push(entry.substring(0,2))
      }else{
        newLabels.push(entry.substring(0,3))
      }
    }
  })
  return newLabels;
}

function fillData(info, style, primaryColor, secondaryColor) {
  return {
    type: style.series.type,
    data: {
      labels: truncateLabels(info.datasets.current.dateLabels),
      datasets: [
        {
          label: info.datasets.compareTo.label,
          data: info.datasets.compareTo.data,
          borderDash: [5, 5],
          order: 2,
          borderColor: secondaryColor,
          backgroundColor: secondaryColor,
          fill: style.series.compareTo.fill,
          tension: 0.1
        },
        {
          label: info.datasets.current.label,
          data: info.datasets.current.data,
          order: 1,
          borderColor: primaryColor,
          backgroundColor: primaryColor,
          fill: style.series.current.fill,
          tension: 0.1
        }
      ]
    },
    options: {
      plugins: {
        legend: {
          position: 'bottom',
          align: 'center',
          labels: {
            font: {
              size: 14,
            },
            boxHeight: 2,
            boxWidth: 10
          }
        },
        tooltip: {
          titleFont: {
            weight: 'normal'
          },
          bodyFont: {
            weight: "bold"
          },
          callbacks: {
            title: function (tooltipItem){
              if (tooltipItem[0].datasetIndex === 0){
                return (info.datasets.compareTo.dateLabels[tooltipItem[0].dataIndex])
              } else if(tooltipItem[0].datasetIndex === 1){
                return (info.datasets.current.dateLabels[tooltipItem[0].dataIndex])
              }
            },
            label: function(tooltipItem) {

              if (info.isCurrency)
              {
                return formatter.format(parseInt(tooltipItem.parsed.y)/100);
              }
              else
              {
                return tooltipItem.parsed.y.toString() + " " + subject.value ;
              }
            }
          }
        }
      },
      scales: {
        x: {
          grid: {
            display: false,
            drawBorder: false,
          }
        },
        yAxis: {
          display: false,
        }
      },
      maintainAspectRatio: false,
      responsive: true,
    }
  };
}

function fillDataTotalVisits(info, style, primaryColor, secondaryColor) {
  return {
    type: 'bar',
    data: {
      // labels: [],
      labels: [info.datasets.compareTo.dateLabels + " - " + info.datasets.current.dateLabels],
      datasets: [
        {
          label: info.datasets.compareTo.label,
          data: info.datasets.compareTo.data,
          order: 1,
          borderColor: secondaryColor,
          backgroundColor: secondaryColor,
          fill: style.series.current.fill,
          borderRadius: 8
        },
        {
          label: info.datasets.current.label,
          data: info.datasets.current.data,
          borderDash: [5, 5],
          order: 2,
          borderColor: primaryColor,
          backgroundColor: primaryColor,
          fill: style.series.compareTo.fill,
          borderRadius: 8
        },
      ]
    },
    options: {
      plugins: {
        legend: {
          position: 'bottom',
          align: 'center',
          labels: {
            font: {
              size: 14
            },
            boxHeight: 4,
            boxWidth: 10
          }
        },
        tooltip: {
          callbacks: {
            title: function (tooltipItem){
              if (tooltipItem[0].datasetIndex === 0){
                return (info.datasets.compareTo.dateLabels[tooltipItem[0].dataIndex])
              } else if(tooltipItem[0].datasetIndex === 1){
                return (info.datasets.current.dateLabels[tooltipItem[0].dataIndex])
              }
            },
            label: function(tooltipItem) {

              if (info.isCurrency)
              {
                return formatter.format(parseInt(tooltipItem.parsed.y)/100);
              }
              else
              {
                return tooltipItem.parsed.y.toString();
              }
            }
          }
        }
      },
      scales: {
        x: {
          display:false,
          grid: {
            display: false,
            drawBorder: false,
          }
        },
        yAxis: {
          display: true,
        }
      },
      maintainAspectRatio: false,
      responsive: true,
    }
  };
}
</script>
